import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { AuctionList, AuctionSearch } from "../../modules/auction/types";
import { GetGoogleToken, GoogleTokenResponse } from './apiTypes'

export const publicApi = createApi({
  reducerPath: "publicApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL + "/public",
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getGoogleToken: builder.query<GoogleTokenResponse, GetGoogleToken>({
      query: (body) => ({
        url: `get-token-by-code-google`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { body: GoogleTokenResponse }, meta, arg) => {
        return response.body;
      },
    }),
    searchProductPublic: builder.query<AuctionList, AuctionSearch>({
      query: (body) => {
        const { page, size, keyword, ...rest } = body;
        return ({
          url: `product/search?page=${page}&size=${size}&keyword=${keyword || ""}&properties=modifiedDate&sortBy=DESC`,
          method: 'POST',
          body: { ...rest, isPublic: 1 }
        })
      },
      transformResponse: (response: { body: AuctionList }, meta, arg) => {
        return response.body;
      }
    }),
    verifyGoogleCaptcha: builder.query<{ success: boolean }, string>({
      query: (token) => `google/capcha?response=${token}`,
      transformResponse: (response: { body: { success: boolean } }, meta, arg) => {
        return response.body;
      }
    })
  }),
})

export default publicApi;
export const {
  useLazyGetGoogleTokenQuery,
  useLazySearchProductPublicQuery,
  useLazyVerifyGoogleCaptchaQuery
} = publicApi

